"use strict";

let $compareBar = $(".compare-bar-wrapper");
let currentSite = $compareBar.attr("data-current-site");
let compareSessionID = `product-compare-${currentSite}`;
let compareSessionEnabled = `product-compare-enabled-${currentSite}`;
let maxSlots = parseInt($(".compare-bar").data("max-slots"), 10);

function compileSlot(product, idx) {
    let pid = product.pid;
    let name = "pid" + idx;

    return (
        `<div class="product-compare-bar-product selected-product">
            <div class="slot" data-pid="${pid}">
                <img alt="${product.altText}" srcset="${product.imgSrc}">
                <button type="button" class="product-compare-bar-product-remove close" aria-label="remove ${product.altText} from compare list"></button>
            </div>
            <input type="hidden" name="${name}" value="${pid}">
        </div>`
    );
}


function redrawCompareSlots() {
    let productsToCompare = getCompareProducts();
    let html = productsToCompare
        .map(function (product, idx) {
            return compileSlot(product, idx);
        })
        .join("");

    // Render empty slots
    if (productsToCompare.length < maxSlots) {
        let numAvailableSlots = maxSlots - productsToCompare.length;

        for (let i = 0; i < numAvailableSlots; i++) {
            html += `<div class="product-compare-bar-product dashed"></div>`;
        }
    }

    $(".compare-bar .product-slots").empty().append(html);
    setCompareButton(productsToCompare.length);

    if (productsToCompare.length === 0) {
        $compareBar.hide();
    } else {
        $compareBar.show();
    }
}

function setCompareButton(numProducts) {
    if (numProducts < 2) {
        $("button.compare").attr("disabled", true);
    } else {
        $("button.compare").removeAttr("disabled");
    }
}

function copyProducts() {
    return getCompareProducts().map(function (product) {
        let proxy = {};

        Object.keys(product).forEach(function (key) {
            proxy[key] = product[key];
        });

        return proxy;
    });
}

function selectProduct(pid, imgSrc, altText) {
    let productsToCompare = copyProducts() || [];

    if (productsToCompare.length < maxSlots) {
        productsToCompare.push({
            pid: pid,
            imgSrc: imgSrc,
            altText: altText
        });

        setCompareProducts(productsToCompare);
        if (productsToCompare.length === maxSlots) {
            $("input.product-tile-compare-checkbox[type=checkbox]:not(:checked)").attr("disabled", true);
        }

        redrawCompareSlots();
    }
}

function deselectProduct(pid) {
    let productsToCompare = copyProducts() || [];

    setCompareProducts(productsToCompare.filter(function (product) {
        return product.pid !== pid;
    }));

    $("input#" + pid).prop("checked", false);
    $("input.product-tile-compare-checkbox[type=checkbox]:not(:checked)").removeAttr("disabled");
    redrawCompareSlots();
}

function setCompareProducts(products) {
    return sessionStorage.setItem(compareSessionID, JSON.stringify({"list": products}));
}

function getCompareProducts() {
    return JSON.parse(sessionStorage.getItem(compareSessionID)).list;
}

function clearCompareBar() {
    getCompareProducts().forEach(function (product) {
        $(this).trigger("compare:deselected", { pid: product.pid });
    });
    setCompareProducts([]);
    $(".compare input").prop("checked", false);
    $(".compare input[type=checkbox]:not(:checked)").removeAttr("disabled");
    redrawCompareSlots();
}


function handleInitialComparison() {
    let productsToCompare = getCompareProducts();

    if (productsToCompare.length) {
        productsToCompare.forEach(function (product) {
            $("input#" + product.pid).prop("checked", "checked").removeAttr("disabled");
        });
    }

    redrawCompareSlots();
}

module.exports = {
    initCompareSession: function () {
        let sessionProductsObj = sessionStorage.getItem(compareSessionID);

        if (!sessionProductsObj) {
            setCompareProducts([]);
        } else {
            let productsLength = getCompareProducts().length;
            let spaceLeft = productsLength < maxSlots;

            if (productsLength === 0) {
                $("input.product-tile-compare-checkbox[type=checkbox]").removeAttr("disabled").prop("checked", false);
            } else if (spaceLeft) {
                $("input.product-tile-compare-checkbox[type=checkbox]:not(:checked)").removeAttr("disabled");
            } else {
                $("input.product-tile-compare-checkbox[type=checkbox]:not(:checked)").attr("disabled", true);
            }
        }
    },
    handleCompareClick: function () {
        $("div.page").on("click", ".compare input[type=checkbox]", function () {
            let pid = $(this).attr("id");
            let checked = $(this).is(":checked");
            let $img = $(this).closest(".product-tile").find(".tile-image").first();
            let imgSrc = $img.attr("data-srcset");
            let altText = $img.attr("alt");

            if (checked) {
                selectProduct(
                    pid,
                    imgSrc,
                    altText
                );
                $(this).trigger("compare:selected", { pid: pid });
            } else {
                deselectProduct(
                    pid
                );
                $(this).trigger("compare:deselected", { pid: pid });
            }
        });
    },
    handleClearAll: function () {
        $(".compare-bar a.clear-all").on("click", function (e) {
            e.preventDefault();
            clearCompareBar();
        });
    },
    deselectProductOnCompareBar: function () {
        $(".compare-bar").on("click", ".close", function () {
            let pid = $(this).closest(".slot").data("pid").toString();
            deselectProduct(pid);
            $(this).trigger("compare:deselected", { pid: pid });
        });
    },
    selectCheckedProducts: function () {
        $(".product-grid").ready(handleInitialComparison);
        $("body").on("search:filter", handleInitialComparison);
    },
    setComparatorBar: function () {
        let $toggle = $(".js-enable-comparator");
        let initialState = sessionStorage.getItem(compareSessionEnabled) === "true";

        $toggle.prop("checked", initialState);
        Promise.resolve().then(() => {
            $toggle.trigger("change");
        });
    },
    handleCompareBarEvent: function () {
        let $body = $("body");

        $body.on("change", ".js-enable-comparator", function () {
            let state = $(this).prop("checked");

            if (state) {
                $(".product-tile .compare").toggleClass("hidden", false);

                if (getCompareProducts().length > 0) {
                    $compareBar.show();
                }
            } else {
                $(".product-tile .compare").toggleClass("hidden", true);
                $compareBar.hide();
            }

            sessionStorage.setItem(compareSessionEnabled, state);
        });

        $body.on("keydown", ".compare-toggle__switch", function (e) {
            if (e.key && (e.key === "Enter" || e.key === " " || e.key === "Space")) {
                e.preventDefault();

                let $compareToggle = $(this).find(".js-enable-comparator");

                $compareToggle.prop("checked", !$compareToggle.is(":checked")).trigger("change");
            }
        });

        $body.on("keydown", ".product-tile-compare-checkbox-label", function (e) {
            if (e.key && (e.key === "Enter" || e.key === " " || e.key === "Space")) {
                e.preventDefault();

                let $productCompareToggle = $(this).parent().find(".product-tile-compare-checkbox");

                $productCompareToggle.trigger("click");
            }
        });
    }
};
